import { Link } from 'react-router-dom';

const articleCards = [
  {
    slug: 'itaobuy-spreadsheet-sicuro',
    title: 'Itaobuy Spreadsheet è Sicuro?',
    excerpt: 'Analisi completa sulla sicurezza e affidabilità. Tutto quello che devi sapere prima di utilizzare Itaobuy Spreadsheet per navigare in modo sicuro e consapevole.',
    category: 'Sicurezza',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20product%20photography%20of%20a%20white%20minimalist%20sneaker%20with%20a%20subtle%20gold%20padlock%20charm%20beside%20it%20on%20warm%20gray%20textured%20surface%2C%20soft%20diffused%20morning%20light%2C%20trust%20and%20security%20aesthetic%2C%20editorial%20style%2C%20clean%20elegant%20composition%2C%20neutral%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-sicurezza-01&orientation=landscape',
  },
  {
    slug: 'migliori-sneakers-itaobuy-spreadsheet',
    title: 'Migliori Sneakers su Itaobuy',
    excerpt: 'Guida definitiva per trovare scarpe di qualità. Confronto prezzi, categorie, foto QC e consigli pratici per scegliere le sneakers perfette.',
    category: 'Scarpe',
    readTime: '11 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20three%20stylish%20sneakers%20in%20cream%2C%20sage%20green%2C%20and%20warm%20beige%20on%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20fashion%20catalog%20style%2C%20clean%20composition%2C%20neutral%20earthy%20tones%2C%20high%20end%20product%20photography%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-sneakers-02&orientation=landscape',
  },
  {
    slug: 'itaobuy-spreadsheet-principianti',
    title: 'Guida per Principianti',
    excerpt: 'Tutorial completo passo dopo passo per chi inizia. Impara a navigare tra le categorie e a trovare i prodotti che cerchi in pochi minuti.',
    category: 'Guida',
    readTime: '9 min',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20flat%20lay%20of%20a%20notebook%2C%20pen%2C%20and%20a%20single%20elegant%20beige%20sneaker%20on%20warm%20light%20gray%20desk%2C%20soft%20morning%20light%2C%20beginner%20friendly%20aesthetic%2C%20editorial%20style%2C%20organized%20calm%20composition%2C%20neutral%20warm%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-principianti-03&orientation=landscape',
  },
  {
    slug: 'categorie-itaobuy-spreadsheet',
    title: 'Tutte le Categorie',
    excerpt: 'Esplora ogni sezione prodotti disponibile: scarpe, felpe, t-shirt, giacche, accessori. Guida dettagliata a tutte le categorie merceologiche.',
    category: 'Categorie',
    readTime: '13 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20overhead%20circular%20flat%20lay%20of%20fashion%20accessories%20including%20a%20white%20sneaker%2C%20beige%20hoodie%2C%20gray%20cap%2C%20sunglasses%2C%20leather%20bag%2C%20and%20watch%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20organized%20catalog%20style%2C%20clean%20composition%2C%20neutral%20earthy%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-categorie-04&orientation=landscape',
  },
  {
    slug: 'recensione-itaobuy-spreadsheet',
    title: 'Recensione Completa 2026',
    excerpt: 'Analisi obiettiva con pro, contro e opinioni reali. Scopri se Itaobuy Spreadsheet è lo strumento giusto per le tue esigenze di ricerca prodotti.',
    category: 'Recensione',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20product%20photography%20of%20a%20clean%20white%20sneaker%20next%20to%20a%20small%20notepad%20with%20pen%20on%20warm%20beige%20textured%20surface%2C%20soft%20natural%20light%2C%20review%20evaluation%20aesthetic%2C%20editorial%20style%2C%20clean%20minimal%20composition%2C%20neutral%20tones%2C%20thoughtful%20atmosphere%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-recensione-05&orientation=landscape',
  },
  {
    slug: 'itaobuy-spreadsheet-alternative',
    title: 'Itaobuy vs Alternative',
    excerpt: 'Confronto completo con altri strumenti di ricerca prodotti. Analisi delle differenze, vantaggi e svantaggi per scegliere la soluzione migliore.',
    category: 'Confronto',
    readTime: '11 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20still%20life%20of%20two%20contrasting%20sneakers%20side%20by%20side%2C%20one%20white%20minimalist%20and%20one%20dark%20olive%2C%20on%20warm%20cream%20surface%2C%20soft%20light%2C%20comparison%20aesthetic%2C%20editorial%20style%2C%20balanced%20composition%2C%20neutral%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-alternative-06&orientation=landscape',
  },
  {
    slug: 'qualita-prodotti-itaobuy',
    title: 'Valutare la Qualità',
    excerpt: 'Guida alle foto QC e ai controlli qualità. Impara a riconoscere i prodotti migliori e a evitare brutte sorprese con i nostri criteri di valutazione.',
    category: 'Qualità',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20artistic%20product%20photography%20of%20sneaker%20stitching%20detail%20with%20a%20small%20magnifying%20glass%20on%20warm%20cream%20surface%2C%20soft%20directional%20light%2C%20quality%20inspection%20aesthetic%2C%20editorial%20style%2C%20clean%20composition%2C%20neutral%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-qualita-07&orientation=landscape',
  },
  {
    slug: 'itaobuy-spreadsheet-moda-uomo',
    title: 'Moda Uomo',
    excerpt: 'Guida all\'abbigliamento maschile: sneakers, felpe, giacche e accessori. Consigli su come creare outfit completi e alla moda con Itaobuy Spreadsheet.',
    category: 'Moda Uomo',
    readTime: '9 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20mens%20fashion%20essentials%20with%20white%20sneakers%2C%20dark%20olive%20bomber%20jacket%2C%20beige%20cap%2C%20and%20leather%20watch%20on%20warm%20gray%20surface%2C%20soft%20morning%20light%2C%20masculine%20editorial%20style%2C%20clean%20composition%2C%20neutral%20earthy%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-moda-uomo-08&orientation=landscape',
  },
  {
    slug: 'itaobuy-spreadsheet-moda-donna',
    title: 'Moda Donna',
    excerpt: 'Scopri borse, scarpe, accessori e abbigliamento femminile. La guida completa alla moda donna con consigli su stile, tendenze e shopping intelligente.',
    category: 'Moda Donna',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20womens%20fashion%20with%20beige%20leather%20handbag%2C%20elegant%20white%20heels%2C%20silk%20scarf%2C%20and%20delicate%20gold%20accessories%20on%20warm%20cream%20surface%2C%20soft%20feminine%20light%2C%20editorial%20style%2C%20clean%20elegant%20composition%2C%20neutral%20warm%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-moda-donna-09&orientation=landscape',
  },
  {
    slug: 'itaobuy-spreadsheet-guida-shopping',
    title: 'Guida allo Shopping',
    excerpt: 'Strategie per acquistare in modo intelligente. Consigli pratici per risparmiare, trovare le migliori offerte e fare scelte consapevoli con Itaobuy.',
    category: 'Shopping',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20product%20flat%20lay%20of%20a%20stylish%20shopping%20bag%20next%20to%20white%20sneakers%2C%20folded%20beige%20sweater%2C%20and%20small%20accessories%20on%20warm%20cream%20surface%2C%20soft%20daylight%2C%20smart%20shopping%20aesthetic%2C%20editorial%20style%2C%20organized%20composition%2C%20neutral%20warm%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-shopping-10&orientation=landscape',
  },
];

export default function ArticlesSection() {
  return (
    <section id="articoli" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
            Articoli SEO
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Guide e Approfondimenti <span className="italic">Itaobuy Spreadsheet</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Scopri tutti i nostri articoli originali per approfondire il mondo di Itaobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article) => (
            <Link
              key={article.slug}
              to={`/articoli/${article.slug}`}
              className="group bg-white rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-semibold bg-accent-100 text-accent-700 px-2.5 py-1 rounded-full">{article.category}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 mt-4 group-hover:gap-2.5 transition-all whitespace-nowrap">
                  Leggi l&apos;articolo
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articoli/itaobuy-spreadsheet-guida-completa"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-600 hover:bg-primary-700 text-white font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            Leggi la Guida Completa
          </Link>
        </div>
      </div>
    </section>
  );
}